import React, { useEffect, useState } from 'react';
import lodash from "lodash"
import useTranslation from "../../../../../../hooks/use-translation";
import ic_health_hub from '../../../../../../images/ic_jiohealthhub.svg';
import downloadIcon from '../../../../../../images/downloadIcon.svg';
import backArrow from '../../../../../../images/cowinBackArrow.svg';
import Input from "../../../../../VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm";
import QRCode from '../../../../../MyQrCode';
import { useIsDesktop, useIsTablet } from '../../../../../../hooks/breakpoints';
import { parseQueryString } from '../../../../../../utils/utils';
import { isMobile } from '../../../../../../utils/utils';

import './qrCode.css';

const QRCodeComponent = ({ qrData, onBackClick }) => {
  const { t } = useTranslation();
  const [name, _setName] = useState("");
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();
  const [shareClicked, setShareClicked] = useState(false);
  const params = parseQueryString();

  const getImageUrl = () => {
    const canvas = document.getElementById("react-qrcode-logo");
    if (!canvas) {
      return
    }
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    return pngUrl
  }

  const shareQr = () => {
    setShareClicked(true)
    downloadQR()
    setShareClicked(false)
  }

  const downloadQR = () => {
    const pngUrl = getImageUrl()
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "JioHealth-VaccinationDetails.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const shareImageOnMobile = (image) => {
    if (navigator.canShare && navigator.canShare({ files: image })) {
      navigator.share({
        files: image,
        title: 'JioHealth-VaccinationDetails',
        text: 'JioHealth-VaccinationDetails',
      })
        .then(() => console.log('Share was successful.'))
        .catch((error) => console.log('Sharing failed', error));
    } else {
      downloadQR();
    }
  }

  const shareQrOnMobile = () => {
    setShareClicked(true)
    const pngUrl = getImageUrl()
    let filesArray = []
    fetch(pngUrl)
      .then(function (response) {
        return response.blob()
      })
      .then(blob => {
        const file = new File([blob], "JioHealth-VaccinationDetails.jpg", { type: 'image/jpeg' });
        filesArray = [file];
        shareImageOnMobile(filesArray)
        setShareClicked(false)
      })
  }

  useEffect(() => {
    const user_name = lodash.get(params, "t");
    try { _setName(atob(user_name)); }
    catch (e) { _setName("") }
  }, [])

  return (
    <>
      {(isDesktop || isTablet) &&
        <div className="qr-code-div">
          <img src={downloadIcon} className="download-qr-button" alt="download" onClick={shareQr} />
          <div className="qr-code-patient-info">
            <div className="qr-code-patient-info-name">{qrData.name}</div>
            <div className="qr-code-patient-info-booked-date-label">{t("BOOKED_DATE")}</div>
            <div className="qr-code-patient-info-booked-date-value">{qrData.bookedDate}</div>
          </div>
          <div className="qr-code-wrapper">
            <QRCode value={qrData.value} logoImage={ic_health_hub} logoWidth={170} logoHeight={170} logoOpacity={0.6} qrStyle={'squares'} size={312} />
          </div>
          <div className="booking-qr-text">
            {t('BOOKING_QR_TEXT')}
          </div>
        </div>
      }
      {!(isDesktop || isTablet) &&
        <div className="qr-code-div-mobile-wrapper">
          <div className="back-arrow-div">
            <img className="back-arrow-img" src={backArrow} alt="back-arrow" onClick={() => onBackClick(false)} />
            {t("QR_CODE")}
          </ div>
          <div className="qr-code-div-mobile">
            <QRCode value={qrData.value} logoImage={ic_health_hub} logoWidth={150} logoHeight={150} logoOpacity={0.6} qrStyle={'squares'} size={250} />
            <div className="booking-qr-text-mobile">
              {t('BOOKING_QR_TEXT_MOBILE')} {name}
            </div>
          </div>
          <Input type="button" value={isMobile.iOS() ? t('DOWNLOAD') : t('SHARE')} addClassInput="download-qr-button-mobile" onClick={shareQrOnMobile} />
        </div>
      }
    </>
  );
};

export default QRCodeComponent;